<template>
  <div class="md:flex md:items-center md:justify-between">
    <div class="flex-1 min-w-0">
      <h2 class="text-2xl font-bold leading-7 dark:text-white sm:text-3xl sm:truncate"><slot name="title"></slot></h2>
    </div>
    <div class="mt-4 flex md:mt-0 md:ml-4">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>